var SessionStore = /** @class */ (function () {
    function SessionStore(_a) {
        var customId = _a.customId;
        if (customId) {
            this.custom = JSON.parse(sessionStorage.getItem(customId) || '{}');
        }
    }
    SessionStore.prototype.storeCustom = function (id, data) {
        this.custom = Object.assign({}, this.custom, data);
        sessionStorage.setItem(id, JSON.stringify(this.custom));
    };
    return SessionStore;
}());
export default SessionStore;
//# sourceMappingURL=SessionStore.js.map